import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import storeReducer from "./reducers/storeReducer";
import couponReducer from "./reducers/couponReducer";
import couponViewReducer from "./reducers/couponViewReducer";
import couponVoteReducer from "./reducers/couponVoteReducer";
import couponCommentReducer from "./reducers/couponCommentReducer";
import couponLikeReducer from "./reducers/couponLikeReducer";
import categoryReducer from "./reducers/categoryReducer";
import searchReducer from "./reducers/searchReducer";
import authReducer from "./reducers/authReducer";
import userReducer from "./reducers/userReducer";
import translationReducer from "./reducers/translationReducer";
import visitorReducer from "./reducers/visitorReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  store: storeReducer,
  coupon: couponReducer,
  couponView: couponViewReducer,
  couponVote: couponVoteReducer,
  couponComment: couponCommentReducer,
  couponLike: couponLikeReducer,
  category: categoryReducer,
  search: searchReducer,
  translation: translationReducer,
  visitor: visitorReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

export { store };
